import { siteName, siteTagline, heroSlogan, heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent pointer-events-none"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex flex-col items-start gap-5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide font-label">
              <i className="ri-flashlight-line text-sm"></i>
              {siteTagline}
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              {siteName}
              <span className="block text-primary-500 mt-1">网红八卦内幕与塌房丑闻爆料合集</span>
            </h1>

            <p className="text-base sm:text-lg text-foreground-600 font-body leading-relaxed max-w-xl">
              {heroSlogan}
            </p>

            <p className="text-sm text-foreground-500 font-body leading-relaxed max-w-xl">
              网红黑料网是国内领先的网红八卦内幕聚合平台，覆盖全网3000+网红的最新黑料动态。从感情塌房到商业翻车，从人设崩塌到法律纠纷，每日24小时不间断更新，为你提供全网最全、最快、最真实的网红丑闻与吃瓜资讯。在这里，每一条爆料都有图有真相，每一个大瓜都经得起推敲。
            </p>

            <div className="flex flex-wrap items-center gap-5 sm:gap-8 pt-2">
              {heroStats.map((stat, i) => (
                <div key={i} className="flex flex-col items-start gap-0.5">
                  <span className="text-xl sm:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </span>
                  <span className="text-xs text-foreground-500 font-label">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-3 w-full sm:w-auto">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-secondary-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-secondary-50 hover:border-secondary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-mail-send-line"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20composition%20with%20deep%20crimson%20and%20amber%20gradients%2C%20shattered%20glass%20texture%20overlay%2C%20mysterious%20editorial%20journalism%20atmosphere%2C%20stylized%20geometric%20shapes%20suggesting%20exposure%20and%20revelation%2C%20modern%20digital%20media%20aesthetic%2C%20high%20contrast%20cinematic%20lighting%2C%20clean%20minimal%20composition&width=960&height=720&seq=hero-visual&orientation=landscape"
                alt="网红黑料 - 网红八卦内幕与塌房丑闻爆料合集"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tl from-primary-900/30 via-transparent to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}